export default __webpack_public_path__ + "fb5b5ac4daaf175a378616cb2c2998a0.png";